import { useEffect, useMemo, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'

import i18next from 'i18next'

import { getAirlinesMiniInfo } from '../../../../info/allAirlines'

import {
  Card,
  Content,
  Image,
  Lists,
  MainInformation,
  OtherArticles,
  Wrapper
} from './style'

export const PartnersInfoComponent = () => {
  const { t, language } = i18next;
  const { airline } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [airlineData, setAirlineData] = useState(null);
  const [airlinesList, setAirlinesList] = useState([]);

  useEffect(() => {
    const getAirlineData = async () => {
      const airlineData = await import(`../../../../info/airlinesInfoJsons/${airline}.json`);

      if (!!airlineData?.default) {
        setAirlineData(airlineData?.default);
        setIsLoading(false);
      } else {
        navigate("/");
      }
    };

    if (airline) {
      getAirlineData();
    }
  }, [airline]);

  useEffect(() => {
    const getAirlinesAll = async () => {
      const airlines = await getAirlinesMiniInfo(10);

      setAirlinesList(airlines);
    };

    getAirlinesAll();
  }, []);

  const mainContent = useMemo(() => airlineData?.content?.[language]?.generalInfo, [airlineData, language]);
  const cardContent = useMemo(() => airlineData?.content?.[language]?.origin, [airlineData, language]);

  return (
    <Wrapper>
      {isLoading ? (
        <div>Loading ...</div>
      ) : (
        <Content>
          <div>
            <MainInformation>
              {mainContent.map((item, index) => {
                return <div key={index} dangerouslySetInnerHTML={{ __html: `${item.content}` }} />;
              })}
            </MainInformation>

            <Card>
              <Image>
                <img src={airlineData.imageUrl} alt={airlineData.key} width={250} />
              </Image>
              {cardContent.map((item, index) => (
                <div key={index} dangerouslySetInnerHTML={{ __html: `${item.content}` }} />
              ))}
            </Card>
          </div>

          <h3>{t("inner_links")}</h3>

          <OtherArticles>
            <Lists>
              {airlinesList
                .map(item => {
                  if (item.name !== airline) {
                    return (
                      <li key={item.key}>
                        <img src={item.smImageUrl} alt={item.key} />
                        <Link to={`/airlines/${item.key}`}>
                          <span>{item.name[language]}</span>
                        </Link>
                      </li>
                    );
                  }
                })}
            </Lists>
          </OtherArticles>
        </Content>
      )}
    </Wrapper>
  );
};
